import maplibregl from 'maplibre-gl'
import { DOM_MARKER_MIN_ZOOM, STATUS_COLORS } from '../utils/map-constants.js'

// Colores del pill themed via CSS vars (resuelven contra :root): en temas
// oscuros queda pill oscuro + texto claro; en el tema claro 'diurno', pill
// claro + texto navy, legible sobre mapa claro.
var MARKER_STYLES = '.dom-marker{display:flex;align-items:center;gap:4px;padding:2px 8px;background:var(--kln-bg-overlay,rgba(10,14,26,0.85));border:1px solid var(--kln-border-normal,rgba(255,255,255,0.12));border-radius:6px;font-family:"Public Sans",sans-serif;font-size:11px;color:var(--kln-text,#fff);white-space:nowrap;pointer-events:none;transform:translateY(8px)}.dom-marker__dot{width:6px;height:6px;border-radius:50%;flex-shrink:0}.dom-marker__name{max-width:120px;overflow:hidden;text-overflow:ellipsis}.dom-marker__speed{color:var(--kln-text-muted,rgba(255,255,255,0.6));font-size:10px}.maplibregl-marker.dom-marker-smooth{transition:transform 1s ease}'

var stylesInjected = false
function injectStyles() {
  if (stylesInjected) return
  var style = document.createElement('style')
  style.textContent = MARKER_STYLES
  document.head.appendChild(style)
  stylesInjected = true
}

export { injectStyles as injectDomMarkerStyles }

export class DomMarkerManager {
  constructor() {
    this.map = null
    this.markers = new Map()
    this.active = false
  }

  init(map) {
    this.map = map
    injectStyles()
    var self = this
    map.on('zoomend', function() { self._checkZoom() })
    map.on('moveend', function() { if (self.active) self._updateVisibleMarkers() })
    this._checkZoom()
  }

  updateMarker(monitorId, coords, props) {
    if (!this.active) return
    var existing = this.markers.get(monitorId)
    if (existing) {
      existing.setLngLat(coords)
      this._updateMarkerContent(existing, props)
    }
  }

  removeMarker(monitorId) {
    var marker = this.markers.get(monitorId)
    if (marker) { marker.remove(); this.markers.delete(monitorId) }
  }

  clear() {
    this.markers.forEach(function(marker) { marker.remove() })
    this.markers.clear()
  }

  refreshFromMonitors(monitors) {
    if (!this.active || !this.map) return
    var bounds = this.map.getBounds()
    var visibleIds = {}

    var keys = Object.keys(monitors)
    for (var i = 0; i < keys.length; i++) {
      var id = keys[i]
      var monitor = monitors[id]
      if (monitor.isStatic) continue
      var coords = monitor.coordinates
      if (!bounds.contains(coords)) continue
      visibleIds[id] = true
    }

    var self = this
    for (var j = 0; j < keys.length; j++) {
      var mid = keys[j]
      if (!visibleIds[mid]) continue
      var mon = monitors[mid]
      var existing = self.markers.get(mid)
      if (existing) {
        existing.setLngLat(mon.coordinates)
        self._updateMarkerContent(existing, {
          title: mon.title,
          speed: mon.data.position ? mon.data.position.speed : 0,
          status: mon.status,
        })
      } else {
        self._createMarker(mid, mon)
      }
    }

    this.markers.forEach(function(marker, id) {
      if (!visibleIds[id]) { marker.remove(); self.markers.delete(id) }
    })
  }

  _checkZoom() {
    if (!this.map) return
    var shouldBeActive = this.map.getZoom() >= DOM_MARKER_MIN_ZOOM
    if (shouldBeActive && !this.active) { this.active = true }
    else if (!shouldBeActive && this.active) { this.active = false; this.clear() }
  }

  _updateVisibleMarkers() { /* called from MapV2.vue which passes monitors */ }

  _createMarker(monitorId, monitor) {
    var el = document.createElement('div')
    el.className = 'dom-marker'
    el.dataset.monitorId = monitorId

    var dot = document.createElement('span')
    dot.className = 'dom-marker__dot'
    dot.style.background = STATUS_COLORS[monitor.status] || STATUS_COLORS.idle
    el.appendChild(dot)

    var nameSpan = document.createElement('span')
    nameSpan.className = 'dom-marker__name'
    nameSpan.textContent = monitor.title || ''
    el.appendChild(nameSpan)

    var speedSpan = document.createElement('span')
    speedSpan.className = 'dom-marker__speed'
    speedSpan.textContent = this._formatSpeed(monitor.data.position ? monitor.data.position.speed : 0)
    el.appendChild(speedSpan)

    var marker = new maplibregl.Marker({ element: el, anchor: 'top' })
      .setLngLat(monitor.coordinates)
      .addTo(this.map)

    // Add smooth transition class to MapLibre's wrapper element
    var wrapperEl = marker.getElement().parentElement || marker.getElement()
    if (wrapperEl && wrapperEl.classList) {
      wrapperEl.classList.add('dom-marker-smooth')
    }

    this.markers.set(monitorId, marker)
  }

  _updateMarkerContent(marker, props) {
    var el = marker.getElement()
    if (!el) return
    var nameEl = el.querySelector('.dom-marker__name')
    var speedEl = el.querySelector('.dom-marker__speed')
    var dotEl = el.querySelector('.dom-marker__dot')
    if (nameEl && props.title) nameEl.textContent = props.title
    if (speedEl) speedEl.textContent = this._formatSpeed(props.speed)
    if (dotEl && props.status) dotEl.style.background = STATUS_COLORS[props.status] || STATUS_COLORS.idle
  }

  _formatSpeed(speed) {
    if (!speed || speed < 1) return ''
    return Math.round(speed) + ' km/h'
  }
}
